import {
  bindCurrencyFieldset,
  bindNavLinks,
  getEcwidUrl,
  getInputValue,
  initApp,
  localize, mergeTranslations,
  setInputValue,
  validateInput
} from "./utils";
import "./styles.css";
import { getAppSettings, setAppSettings } from "./app-settings";
import * as allSettingsTrans from "./settings-translations";
import * as allAppSettingsTrans from './app-settings-translations';

initApp();

const fields = [
  {
    fieldId: "home-price",
    getValue: (settings) => settings.myPackHome.rate,
    setValue: (settings, value) => (settings.myPackHome.rate = value),
  },
  {
    fieldId: "home-title",
    getValue: (settings) => settings.myPackHome.title,
    setValue: (settings, value) => (settings.myPackHome.title = value),
  },
  {
    fieldId: "home-desc",
    getValue: (settings) => settings.myPackHome.description,
    setValue: (settings, value) => (settings.myPackHome.description = value),
  },
  {
    fieldId: "collect-price",
    getValue: (settings) => settings.myPackCollect.rate,
    setValue: (settings, value) => (settings.myPackCollect.rate = value),
  },
  {
    fieldId: "collect-title",
    getValue: (settings) => settings.myPackCollect.title,
    setValue: (settings, value) => (settings.myPackCollect.title = value),
  },
  {
    fieldId: "collect-desc",
    getValue: (settings) => settings.myPackCollect.description,
    setValue: (settings, value) => (settings.myPackCollect.description = value),
  },
];

$(function () {
  const storeData = EcwidApp.getPayload();
  const language = storeData.lang;
  const allTrans = mergeTranslations(allSettingsTrans, allAppSettingsTrans);
  const trans = allTrans[language] || allTrans["en"];
  localize(trans);
  bindNavLinks();
  getAppSettings(trans).then((settings) => {
    fields.forEach((field) => setInputValue($(`#${field.fieldId}`), field.getValue(settings)));
    $('#page-subtitle').text(`PostNord ${trans.customerNumber}: ${settings.customerNumber}`);
    $("#save-settings").click(function () {
      const $saveBtn = $(this);
      const valid = fields.reduce((acc, field) => validateInput($(`#${field.fieldId}`)) && acc, true);
      if (valid) {
        fields.forEach((field) => field.setValue(settings, getInputValue($(`#${field.fieldId}`))));
        $saveBtn.addClass("btn-loading");
        setAppSettings(settings, trans).then(() => {
          $saveBtn.removeClass("btn-loading");
        });
      }
    });
  });
  $.get(getEcwidUrl("/profile", storeData), function (profile) {
    const { formatsAndUnits } = profile;
    const { currencyPrefix, currencySuffix } = formatsAndUnits;
    bindCurrencyFieldset({ currencyPrefix, currencySuffix });
  });
});
